/* Keep testimonial audio clear when a shopper switches between reels. */
if (!customElements.get('zahwa-reel-gallery')) {
  customElements.define('zahwa-reel-gallery', class extends HTMLElement {
    constructor() {
      super();
      this.onPlay = (event) => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        this.querySelectorAll('video').forEach((video) => {
          if (video !== event.target && !video.paused) video.pause();
        });
      };
      this.updateControls = () => {
        if (!this.controls) return;
        const max = this.scrollWidth - this.clientWidth;
        const position = Math.abs(this.scrollLeft);
        const style = getComputedStyle(this);
        const endTolerance = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0) + 2;
        this.controls.hidden = max <= 2;
        this.controls.querySelector('[data-reel-direction="-1"]').disabled = position <= 2;
        this.controls.querySelector('[data-reel-direction="1"]').disabled = position >= max - endTolerance;
      };
      this.onStep = (event) => {
        const button = event.target.closest('[data-reel-direction]');
        if (!button || button.disabled) return;
        const card = this.querySelector('.zc-reel');
        if (!card) return;
        const style = getComputedStyle(this);
        const step = card.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
        this.scrollBy({
          left: Number(button.dataset.reelDirection) * step * (style.direction === 'rtl' ? -1 : 1),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
    }
    connectedCallback() {
      this.addEventListener('play', this.onPlay, true);
      this.controls = this.closest('.zc-experiences').querySelector('.zc-reels-controls');
      this.controls?.addEventListener('click', this.onStep);
      this.addEventListener('scroll', this.updateControls, { passive: true });
      this.observer = new ResizeObserver(this.updateControls);
      this.observer.observe(this);
      this.updateControls();
    }
    disconnectedCallback() {
      this.removeEventListener('play', this.onPlay, true);
      this.controls?.removeEventListener('click', this.onStep);
      this.removeEventListener('scroll', this.updateControls);
      this.observer?.disconnect();
    }
  });
}
